module.exports = __webpack_public_path__ + "assets/2c88c594b5b3cfab00366ff907726c84.svg";